<template>
  <div>
    <h3 class="text-inherit mb-0">{{ heading }}</h3>
    <p v-if="notFound" class="text-muted mb-0 mt-1">
      This folder doesn't exist or may have been deleted.
      <router-link to="/me/scenarios">Back to My Scenarios</router-link>
    </p>
  </div>
</template>

<script>
const STORE = "scenarioDirectoriesStore";

// Heading for My Scenarios: the name of the folder being viewed
export default {
  name: "FolderHeading",
  computed: {
    directoryUuid() {
      return this.$route.params.directoryUuid;
    },
    folder() {
      return this.$store.getters[`${STORE}/flatDirectories`].find(
        (d) => d.uuid === this.directoryUuid
      );
    },
    notFound() {
      return (
        !!this.directoryUuid &&
        this.$store.getters[`${STORE}/isTreeLoaded`] &&
        !this.folder
      );
    },
    heading() {
      if (this.notFound) return "Folder not found";
      // At the root, or while the tree is still loading
      return this.folder ? this.folder.name : "My Scenarios";
    },
  },
};
</script>
